export default __webpack_public_path__ + "static/media/background.ffe7518f.jpg";